export default {
  INVESTMENT_SUGGESTION_REPOSITORY: Symbol.for('INVESTMENT_SUGGESTION_REPOSITORY'),
  INVESTMENT_SUGGESTION_STATE_MANAGER: Symbol.for('INVESTMENT_SUGGESTION_STATE_MANAGER'),
  GET_INVESTMENT_SUGGESTION_QUERY: Symbol.for('GET_INVESTMENT_SUGGESTION_QUERY'),
  CREATE_INVESTMENT_SUGGESTION_COMMAND: Symbol.for('CREATE_INVESTMENT_SUGGESTION_COMMAND'),
};
